module.exports = __webpack_public_path__ + "img/30.513aed48.jpg";